var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M29.4 16.34c0-1.063-.095-2.085-.273-3.067H15v5.802h8.073c-.348 1.875-1.405 3.464-2.993 4.527v3.764h4.847c2.837-2.611 4.473-6.457 4.473-11.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M15 31c4.05 0 7.445-1.343 9.927-3.634l-4.847-3.764c-1.344.9-3.062 1.432-5.08 1.432-3.907 0-7.214-2.639-8.393-6.184H1.595v3.886C4.064 27.64 9.136 31 15 31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.607 18.85c-.3-.9-.47-1.861-.47-2.85 0-.989.17-1.95.47-2.85V9.264H1.595C.58 11.289 0 13.58 0 16s.58 4.711 1.595 6.736l5.012-3.886z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M15 6.966c2.202 0 4.18.757 5.734 2.243l4.302-4.302C22.44 2.487 19.043 1 15 1 9.136 1 4.064 4.361 1.595 9.264l5.012 3.886C7.787 9.605 11.093 6.966 15 6.966z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.3eeada4a1e67910180f1ac4913e2be5d.svg";
export { ForwardRef as ReactComponent };